import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function WarrantySection() {
  return (
    <section className="border-b border-slate-200 bg-slate-950">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="grid items-center gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-sm bg-sky-600/20 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-sky-300">
              <ShieldCheck className="h-4 w-4" /> Warranty
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black tracking-tight text-white sm:text-4xl">Manufacturer Warranty Available</h2>
            <p className="mt-4 max-w-2xl text-slate-300">
              HVAC equipment sold by CA HVAC Direct is covered by the applicable manufacturer warranty. Warranty length,
              registration requirements, eligibility and exclusions depend on the manufacturer and the specific equipment.
            </p>
          </div>
          <div className="lg:justify-self-end">
            <Button asChild size="lg" className="rounded-sm bg-white px-8 text-slate-900 hover:bg-slate-100" data-testid="warranty-learn-more">
              <Link to="/policies/warranty">Warranty information <ArrowRight className="h-4 w-4" /></Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
